import axios from 'axios'


//const serverAuthUrl = process.env.NODE_ENV === 'development' && true ? 'http://localhost:7071/api' : 'https://sysfunc.azurewebsites.net/api';
const serverAuthUrl = getServerUrlAuth();

//const serverUrl = process.env.NODE_ENV === 'development' && true ? 'http://localhost:7076/api' : 'https://sysadm.azurewebsites.net/api';
const serverUrl = getServerUrl();

function getServerUrl() {
  if (window.location.hostname.includes('syssiteadmstaging')) {
    return 'https://sysadm-staging.azurewebsites.net/api'
  }
  else if (window.location.hostname.includes('syssiteadmdev')) {
    return 'https://xxxxxxxxxxxxxxx.net/api'
  }
  else {
    return process.env.REACT_APP_ADM_API;
  }
}

function getServerUrlAuth() {
  if (window.location.hostname.includes('syssiteadmstaging')) {
    return 'https://sysfunc-staging.azurewebsites.net/api'
  }
  else if (window.location.hostname.includes('syssiteadmdev')) {
    return 'https://xxxxxxxxxxxxxxx.net/api'
  }
  else {
    return process.env.REACT_APP_AUTH_API;
  }
}

export const logIn = (dados) => {

  localStorage.setItem('un', dados.user);
  localStorage.setItem('saat', dados.tokenId);
  localStorage.setItem('srat', dados.refreshToken);

  return {
    type: 'LOGIN',
    dados
  }
};

export const logOut = () => {
  localStorage.setItem('un', '');
  localStorage.setItem('saat', '');
  localStorage.setItem('srat', '');

  return { type: 'LOGOUT' }
};

export const setDados = (dados) => {
  return {
    type: 'SETDADOS',
    dados
  }
};

export const fetchAuth = () => {

  return (dispatch) => {

    return axios.create({
      baseURL: serverAuthUrl
    });
  }
};

export const fetchNoAuth = () => {

  return (dispatch) => {

    return axios.create({
      baseURL: serverUrl
    });
  }
};

export const fetch = () => {

  return (dispatch) => {

    const tokenId = localStorage.getItem('saat');

    const http = axios.create({
      baseURL: serverUrl
    });

    http.defaults.headers.common['Authorization'] = tokenId;

    http.interceptors.response.use(function (response) {
      return response
    }, function (error) {
      const originalRequest = error.config
      //console.log(originalRequest)  

      if (error.response.status === 401 && !originalRequest._retry) {
        originalRequest._retry = true

        //get refresh token
        const refreshToken = localStorage.getItem('srat');

        const dados = { username: 'username', tokenId, refreshToken };

        //make refresh token request
        return http.post(serverAuthUrl + '/TokenRefresh', dados)
          .then((responseData) => {
            // set new oauth2 info

            localStorage.setItem('saat', responseData.data.tokenId);
            localStorage.setItem('srat', responseData.data.refreshToken);
            dispatch({ type: 'LOGIN', dados: { tokenId: responseData.data.tokenId, refreshToken: responseData.data.refreshToken } })

            http.defaults.headers.common['Authorization'] = responseData.data.tokenId
            originalRequest.headers['Authorization'] = responseData.data.tokenId
            //retry failed request
            console.log('token refreshed');
            return http(originalRequest)
          }).catch(function (error) {
            console.log('token not refreshed');
            localStorage.setItem('un', '');
            localStorage.setItem('saat', '');
            localStorage.setItem('srat', '');
            dispatch({ type: 'LOGOUT' })
          })
      }

      return Promise.reject(error)
    });

    return http;
  }
};